import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../store/useStore';
import '../styles/CartNotificationModal.css';

export default function CartNotificationModal() {
  const navigate = useNavigate();
  const cartNotification = useStore((state) => state.cartNotification);
  const clearCartNotification = useStore((state) => state.clearCartNotification);

  // No auto-close timer - only closes when user clicks Keep Shopping

  if (!cartNotification) {
    return null;
  }

  const handleKeepShopping = () => {
    clearCartNotification();
    navigate('/products');
  };

  const handleGoToCart = () => {
    clearCartNotification();
    navigate('/cart');
  };

  return (
    <div className="cart-notification-overlay">
      <div className="cart-notification-modal">
        <div className="cart-notification-content">
          <p className="notification-message">Item added to cart</p>

          <div className="notification-actions">
            <button className="btn-keep-shopping" onClick={handleKeepShopping}>
              Keep Shopping
            </button>
            <button className="btn-go-to-cart" onClick={handleGoToCart}>
              Go to Cart
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
